let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dstJL")).then(() => parcelRequire('blaFr'));